import React, { useRef, createRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';

import './PastTopicsScroller.scss';

const PastTopicsScroller = React.forwardRef(({ topics, topicsIndexOffset, refTopicAnchors }, theRef) => {
  const { path, url } = useRouteMatch();
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

  for (let i = topicsIndexOffset; i < topicsIndexOffset + topics.length; i++) {
    refTopicAnchors.current[i] = createRef(null);
  }

  const getTopicsGrid = () => {
    let rows = [];
    let columns = [];
    let rowsKey = 0;

    topics.forEach((topic, i) => {
      columns.push(
        <div key={i} className="cpvi-grid-col w4">
          {getTopicElement(topic, i)}
        </div>
      );
      if (columns.length === 3 || i === topics.length - 1) {
        rows.push(
          <div key={rowsKey++} className="cpvi-grid-row">
            {columns}
          </div>
        );
        columns = [];
      } 
    });

    return rows;
  };

  const getTopicElement = (topic, index) => {
    return (
      <div className="innovation-pts-topic-wrapper" ref={refTopicAnchors.current[topicsIndexOffset + index]}>
        <div className="innovation-pts-topic-frame">
          <div
            className="innovation-pts-topic-bubble"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Overview.BubbleImage})`
            }}
          >
            <div className="innovation-pts-topic-title">{topic.Title}</div>
            <Link className="innovation-pts-topic-button-link" to={`${url}/${topic.Path.Text}`}/>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div 
      className={`innovation-past-topics-scroller`}
      ref={theRef}
    >
      <div className="cpvi-grid-container">
        {getTopicsGrid()}
      </div>
      {/*<div className="innovation-ts-inner">
        {
          topics.map((topic, i) => (
            <div
              key={i}
              className="innovation-ts-topic-wrapper"
              style={{
                height: `${sectionHeight}px`
              }}
            >
              { i < topics.length - 1 && <div className="innovation-ts-trail" style={{ height: `${sectionHeight}px` }} /> }
              <TopicElement
                topic={topic}
                bubbleLabels={bubbleLabels}
                mainBubbleSize={mainBubbleSize}
                isVisible={isVisible}
                ref={refTopicAnchors.current[i]}
              />
            </div>
          ))
        }
      </div>*/}
    </div>
  );
});

export default PastTopicsScroller;